import React, { useState, useEffect } from "react";
import Modal from "../../common/components/Modal";
import { usePopup } from "../../common/contexts/PopupContext";
import { frontendUrl } from "../../common/helpers/common";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip } from "react-tooltip";
import { useApp } from "../../common/contexts/AppContext";
import { LuCopyCheck } from "react-icons/lu";
import { LuCopy } from "react-icons/lu";

function EmbedModal({ open, setOpen, title }) {
  const { pages, pageId } = useApp();

  const pg = pages.find((page) => page._id === pageId);
  const { toast } = usePopup();
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal title={title} open={open} setOpen={setOpen}>
      <div className={`my-4`}>
        <div className="pb-1 text-gray-800">
          <div className="flex items-center space-x-8">
            <span>Here's your status embed code</span>
            {!copied ? (
              <CopyToClipboard
                text={
                  '<script src="' +
                  frontendUrl +
                  "embed.js?id=" +
                  pg?.url +
                  '"></script>'
                }
                onCopy={handleCopy}
              >
                <buttons>
                  <LuCopy color="black" size="1.5rem" />
                  <Tooltip anchorSelect="buttons" clickable>
                    <span>Copy Script</span>
                  </Tooltip>
                </buttons>
              </CopyToClipboard>
            ) : (
              <CopyToClipboard
                text={
                  '<script src="' +
                  frontendUrl +
                  "embed.js?id=" +
                  pg?.url +
                  '"></script>'
                }
                onCopy={handleCopy}
              >
                <buttons>
                  <LuCopyCheck color="black" size="1.5rem" />
                  <Tooltip anchorSelect="buttons" clickable>
                    <button>Copied</button>
                  </Tooltip>
                </buttons>
              </CopyToClipboard>
            )}
          </div>
        </div>
        <br />
        <div className="pb-1 text-gray-800">
          <div className="statusPageScript">
            <div className="embedCode">
              &lt;script src="{frontendUrl}embed.js?id={pg?.url}"&gt;
              &lt;/script&gt;
            </div>
          </div>
        </div>
        <br />
      </div>
    </Modal>
  );
}

export default EmbedModal;
